import { render, staticRenderFns } from "./cards.vue?vue&type=template&id=24c51912&scoped=true&"
import script from "./cards.vue?vue&type=script&lang=js&"
export * from "./cards.vue?vue&type=script&lang=js&"
import style0 from "./cards.vue?vue&type=style&index=0&id=24c51912&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c51912",
  null
  
)

export default component.exports